import {
  getTasks as getTasksService,
  getTasksWithParams as getTasksWithParamsService,
  createTask as createTaskService,
  updateTask as updateTaskService,
  updateTaskStatus as updateTaskStatusService,
  deleteTask as deleteTaskService,
} from "services/company/projectManagement/task/taskService";
import {
  getTasksStart,
  getTasksSuccess,
  getTasksFailure,
  createTaskStart,
  createTaskSuccess,
  createTaskFailure,
  updateTaskStart,
  updateTaskSuccess,
  updateTaskFailure,
  updateTaskStatusStart,
  updateTaskStatusSuccess,
  updateTaskStatusFailure,
  deleteTaskStart,
  deleteTaskSuccess,
  deleteTaskFailure,
} from "./taskSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all tasks
export const fetchTasks =
  (params = null) =>
  async (dispatch) => {
    try {
      dispatch(getTasksStart());
      const response = params
        ? await getTasksWithParamsService(params)
        : await getTasksService();

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(getTasksSuccess(response.data));
        return { success: true, data: response.data };
      } else {
        const errorMsg = response?.meta?.message || "Failed to fetch tasks";
        dispatch(getTasksFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Fetch tasks error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to fetch tasks";
      dispatch(getTasksFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Create a new task
export const createNewTask = (taskData) => async (dispatch) => {
  try {
    dispatch(createTaskStart());
    const response = await createTaskService(taskData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createTaskSuccess(response.data));
      showSuccessToast(response?.meta?.message || "Task created successfully!");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create task";
      dispatch(createTaskFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create task error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create task";
    dispatch(createTaskFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update a task
export const updateExistingTask = (taskId, taskData) => async (dispatch) => {
  try {
    dispatch(updateTaskStart());
    const response = await updateTaskService(taskId, taskData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(updateTaskSuccess(response.data));
      showSuccessToast(response?.meta?.message || "Task updated successfully!");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to update task";
      dispatch(updateTaskFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Update task error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to update task";
    dispatch(updateTaskFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update task status
export const updateExistingTaskStatus =
  (taskId, statusData) => async (dispatch) => {
    try {
      dispatch(updateTaskStatusStart());
      const response = await updateTaskStatusService(taskId, statusData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateTaskStatusSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Task status updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update task status";
        dispatch(updateTaskStatusFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update task status error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update task status";
      dispatch(updateTaskStatusFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Delete a task
export const deleteExistingTask = (taskId) => async (dispatch) => {
  try {
    dispatch(deleteTaskStart());
    const response = await deleteTaskService(taskId);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(deleteTaskSuccess(taskId));
      showSuccessToast(response?.meta?.message || "Task deleted successfully!");
      return { success: true };
    } else {
      const errorMsg = response?.meta?.message || "Failed to delete task";
      dispatch(deleteTaskFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Delete task error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to delete task";
    dispatch(deleteTaskFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
